import React from "react";
import { Button, GridItem, useDisclosure } from "@chakra-ui/react";
import { IoAdd } from "react-icons/io5";
import {
  AutoComplete,
  Form,
  Grid,
  Modal,
  NumberInput,
  Select,
  TextInput
} from "components";
import { DOSE_UNIT_OPTIONS, useCurrentCase, useToast } from "duck";
import { FormValues, getValidation, useCreateTablet } from "./duck";

interface CreateProps {
  patientId: number;
}

const Create: React.FC<CreateProps> = ({ patientId }) => {
  const { onClose, onOpen, isOpen } = useDisclosure();
  const onSubmit = useCreateTablet(patientId);

  const toast = useToast({
    status: "success",
    description: "Tablet is added successfully."
  });

  const weight = useCurrentCase(medCase => medCase.data.client.patient.weight);

  return (
    <>
      <Button onClick={onOpen} leftIcon={<IoAdd />}>
        Add
      </Button>

      <Modal title="Tablets" onClose={onClose} isOpen={isOpen}>
        <Form<FormValues>
          {...getValidation()}
          onSubmit={values => {
            const submitResult = onSubmit(values);
            if (submitResult) {
              return submitResult.then(() => {
                onClose();
                toast();
              });
            }
            onClose();
            toast();
          }}
        >
          {({ setValue, getValues }) => (
            <>
              <Grid py={6} templateColumns="repeat(2, 1fr)">
                <GridItem colSpan={2}>
                  <AutoComplete.Medications
                    creatable
                    name="name"
                    label="Name"
                    placeholder="Name"
                    optionValue="name"
                  />
                </GridItem>
                <GridItem>
                  <NumberInput
                    name="dose"
                    label="Dose"
                    placeholder="Dose"
                    min={0}
                    onBlur={() => {
                      const dose = getValues("dose");
                      if (dose) {
                        const dosage = (weight || 0) * dose;
                        setValue("dosage", +dosage.toFixed(3));
                      }
                    }}
                  />
                </GridItem>
                <GridItem mt={8}>
                  <Select
                    name="doseUnit"
                    label="Dose Unit"
                    labelHidden
                    options={DOSE_UNIT_OPTIONS}
                  />
                </GridItem>
                <GridItem colSpan={2}>
                  <NumberInput
                    name="dosage"
                    label="Dosage"
                    placeholder="Dosage"
                    isDisabled
                  />
                </GridItem>
                <GridItem colSpan={2}>
                  <NumberInput
                    name="tabletSize"
                    label="Tablet Size"
                    placeholder="Tablet Size"
                    min={0}
                  />
                </GridItem>
                <GridItem colSpan={2}>
                  <NumberInput
                    name="numberOfTablets"
                    label="Number of Tablets to go Home"
                    placeholder="Number of Tablets to go Home"
                    min={0}
                  />
                </GridItem>
                <GridItem colSpan={2}>
                  <TextInput
                    name="labelInstructions"
                    label="Label Instructions"
                    placeholder="Label Instructions"
                  />
                </GridItem>
              </Grid>
              <Form.Controls submitText="Add Tablet">
                <Button variant="outline" colorScheme="gray" onClick={onClose}>
                  Cancel
                </Button>
              </Form.Controls>
            </>
          )}
        </Form>
      </Modal>
    </>
  );
};

export default Create;
